var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteProjCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-L\\xF6schen"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "L\\xF6schen",
    clipPath: "url(#clip-L\\xF6schen)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1418",
    transform: "translate(-17059 -4691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_543",
    d: "M309.978,18.5a1,1,0,0,0-1,1v10a1,1,0,0,0,2,0v-10a1,1,0,0,0-1-1",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_544",
    d: "M314.978,18.5a1,1,0,0,0-1,1v10a1,1,0,0,0,2,0v-10a1,1,0,0,0-1-1",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_545",
    d: "M321.978,14.5h-4a4,4,0,0,0-4-4h-3a4,4,0,0,0-4,4h-4a1,1,0,0,0,0,2h1v15a3,3,0,0,0,3,3h11a3,3,0,0,0,3-3v-15h1a1,1,0,0,0,0-2m-11-2h3a2,2,0,0,1,2,2h-7a2,2,0,0,1,2-2m8,19a1,1,0,0,1-1,1h-11a1,1,0,0,1-1-1v-15h13Z",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteProjCard);
export default __webpack_public_path__ + "static/media/delete-proj-card.73535d33.svg";
export { ForwardRef as ReactComponent };